// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1FIP4","filesListContainer":"PosDisputesFiles_filesListContainer__1X8An","filesButton":"PosDisputesFiles_filesButton__3K84s"};